// routes
import React from 'react';
import Router from './routes';
// theme
import ThemeProvider from './theme';
// eslint-disable-next-line import/no-unresolved
import '@aws-amplify/ui-react/styles.css';
// components
import ScrollToTop from './components/scroll-to-top';
import { StyledChart } from './components/chart';
import ErrorBoundary from './components/ErrorBoundary';
// contexts
import AuthProvider from './contexts/AuthProvider';
import SensorConnectionProvider from './contexts/SensorConnectionProvider';
// ----------------------------------------------------------------------

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <SensorConnectionProvider>
            <ScrollToTop />
            <StyledChart />
            <Router />
          </SensorConnectionProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
